const ERROR_MAP = {
  "Invalid email or password": "Email o contraseña incorrectos.",
  "Account suspended": "Esta cuenta está suspendida.",
  "Admin access required": "No tenés permisos de administrador.",
  "Too many failed attempts. Please try again later.": "Demasiados intentos fallidos. Probá de nuevo en unos minutos.",
  "Invalid or already used reset link": "Este enlace ya no es válido o ya fue utilizado.",
  "This reset link has expired": "Este enlace ha expirado.",
  "Invalid reset link": "Enlace inválido.",
  "Current password is incorrect": "La contraseña actual es incorrecta.",
  "New password must be at least 8 characters": "La nueva contraseña debe tener al menos 8 caracteres.",
  "Cannot modify admin accounts": "No se pueden modificar cuentas de administrador.",
};

export function translateAdminError(detail) {
  if (!detail) return "Ocurrió un error inesperado.";
  if (Array.isArray(detail)) {
    // FastAPI/Pydantic 422 validation errors come back as a list of {loc, msg, type}
    return detail.map((d) => (typeof d === "string" ? d : d.msg)).filter(Boolean).join(" · ") || "Datos inválidos.";
  }
  if (typeof detail === "object") return detail.msg || "Ocurrió un error inesperado.";
  return ERROR_MAP[detail] || detail;
}
